const Permissions = {
  CONTACT_US_PAGE: {
    name: "Pages.Users.FCNAdmin.Contact",
    detail: "Contact us Page",
  },
  CHAT_ARCHIEVE: {
    name: "Pages.Users.Chat.Archieve",
    detail: "Chat Archive",
  },
  CHAT_INITIATE: {
    name: "Pages.Users.Chat.Initiate",
    detail: "Chat Initiate",
  },
  CONTRACT_DOC_APPROVE: {
    name: "Pages.Users.ContractDoc.Approve",
    detail: "Contract doc approve",
  },
  FUND_FOLLOW: {
    name: "Pages.Users.Fund.Follow",
    detail: "Fund Follow",
  },
  FUND_INVEST: {
    name: "Pages.Users.Fund.Invest",
    detail: "Fund Invest",
  },
  MEETING_SCHEDULE: {
    name: "Pages.Users.Meeting.Schedule",
    detail: "Meeting Schedule",
  },
  CHANGE_USERS_ROLE: {
    name: "Pages.Users.Role.Change",
    detail: "Change Users Role",
  },
  CREATE_USER: {
    name: "Pages.Users.UserCreate",
    detail: "Create User",
  },
  CONTRACT_DOC_UPLOAD: {
    name: "Pages.Users.ContractDoc.Upload",
    detail: "Contract Doc Upload",
  },
  FUND_CREATE: {
    name: "Pages.Users.Fund.Create",
    detail: "Fund Create",
  },
  TEAR_SHEET_UPLOAD: {
    name: "Pages.Users.TearSheetAndPerformanceMetrics.Upload",
    detail: "Tear Sheet Upload",
  },
  FUND_INSIGHT_POST: {
    name: "Pages.Users.FundInsight.Post",
    detail: "Fund Insight Post",
  },
};

export default Permissions;
